<template>
  <div class="object-summary">
    <div
      class="d-flex flex-wrap"
      style="gap: 4px 16px"
    >
      <span v-if="objectTypeLabel"><strong>{{ $t('involvedSummary.object.typeLabel') }}</strong> {{ objectTypeLabel }}</span>
      <span v-if="data.description"><strong>{{ $t('involvedSummary.object.descriptionLabel') }}</strong> {{ data.description }}</span>
      <span v-if="brandModel"><strong>{{ $t('involvedSummary.object.brandModelLabel') }}</strong> {{ brandModel }}</span>
      <span v-if="data.quantity"><strong>{{ $t('involvedSummary.object.quantityLabel') }}</strong> {{ data.quantity }}</span>
      <span v-if="data.serial_number"><strong>{{ $t('involvedSummary.object.serialNumberLabel') }}</strong> {{ data.serial_number }}</span>
    </div>
    <div
      v-if="data.observation"
      class="text-muted small mt-1"
    >
      {{ data.observation }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ObjectSummary',
  props: {
    data: { type: Object, default: () => ({}) },
  },
  computed: {
    brandModel() {
      return [this.data.brand, this.data.model].filter(Boolean).join(' ')
    },
    objectTypeLabel() {
      const map = {
        arma: this.$t('involvedSummary.object.objectTypes.arma'),
        eletronico: this.$t('involvedSummary.object.objectTypes.eletronico'),
        documento: this.$t('involvedSummary.object.objectTypes.documento'),
        joia: this.$t('involvedSummary.object.objectTypes.joia'),
        outro: this.$t('involvedSummary.object.objectTypes.outro'),
      }
      return map[this.data.object_type] || this.data.object_type || ''
    },
  },
}
</script>
